import { BreakWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Break')
export class BreakConnectorProvider extends ConnectorProvider<BreakWorkflowNode> {}
